import { OSearchService } from "./../../../overrideModules/search/osearch.service";
import { API_URLS } from "./../../../shared/API_URLS";
import { EntityService } from "./../../../shared/services/entity.service";
import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  NbMediaBreakpointsService,
  NbMenuService,
  NbSidebarService,
  NbThemeService,
  NbSearchService,
} from "@nebular/theme";

import { UserData } from "../../../@core/data/users";
import { LayoutService } from "../../../@core/utils";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { OverrideService } from "../../../shared/services/override.service";

@Component({
  selector: "ngx-header",
  styleUrls: ["./header.component.scss"],
  templateUrl: "./header.component.html",
})
export class HeaderComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any = { email: "BeautyDoz" };

  themes = [
    {
      value: "default",
      name: "Light",
    },
    {
      value: "dark",
      name: "Dark",
    },
    {
      value: "cosmic",
      name: "Cosmic",
    },
    {
      value: "corporate",
      name: "Corporate",
    },
  ];

  currentTheme = "default";

  userMenu = [{ title: this.translate.instant("Log out"), link: "auth/login" }];

  constructor(
    private sidebarService: NbSidebarService,
    private themeService: NbThemeService,
    private router: Router,
    public override: OverrideService,
    private translate: TranslateService,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private searchService: NbSearchService,
    private entity: EntityService,
    private searchS: OSearchService
  ) {
    this.searchService.onSearchSubmit().subscribe((data: any) => {
      this.search(data.term);
    });
  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;
    // console.log('email ', atob(sessionStorage.getItem(btoa('email'))))
    this.user.email = atob(sessionStorage.getItem(btoa("email")));

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$)
      )
      .subscribe(
        (isLessThanXl: boolean) => (this.userPictureOnly = isLessThanXl)
      );

    this.themeService
      .onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$)
      )
      .subscribe((themeName) => (this.currentTheme = themeName));
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, "menu-sidebar");
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.router.navigate(["/"]);
  }
  search(searchBy) {
    let url = API_URLS.search.search;
    url += "?word=" + searchBy;
    url += "&lang=" + this.override.currentLang;
    this.entity.getData(url).then((res) => {
      res.subscribe((data) => {
        this.searchS.searchResult = data;

        if (this.router.url.includes("searchResults")) {
          this.router.navigate(["/"]).then((res) => {
            this.router.navigate(["pages", "searchResults"]);
          });
        } else {
          this.router.navigate(["pages", "searchResults"]);
        }
      });
    });
  }
}
